import { datalabHttp } from '@dbl/services/common';
import { AxiosRequestConfig } from 'axios';

// 获取上传文件数据预览接口
export function getPreviewData(params: any) {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/local_data_preview',
    method: 'post',
    data: params,
  };
  return datalabHttp(options);
}

// 把上传文件数据保存成一个表
export function savePersonalData(params: any) {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/local_data_save',
    method: 'post',
    data: params,
  };
  return datalabHttp(options);
}
// 获取列表数据
export function getPersonalDataList(params: any) {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/local_data_tables',
    method: 'post',
    data: params,
  };
  return datalabHttp(options);
}
export function deletePersonalData(params: any) {
  const options: AxiosRequestConfig = {
    url: 'api/v1/datalab/delete_table',
    method: 'post',
    data: params,
  };
  return datalabHttp(options);
}